<template>
  <div class="flex flex-col justify-center items-center px-4">
    <img src="@/assets/razvoj.png" alt="Šola" style="max-height:20vh">
    <h1 class="text-center uppercase bold mt-8 mb-2">Razvoj</h1>
    <p class="text-center font-light">Predstavlja širok spekter priložnosti za osebnostno rast tekom odraščanja in izgradnjo v močno osebnost, ki bo v življenju lahko sledila svojim ciljem.</p>
  </div>
</template>